import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { CircularProgress, Grid } from '@mui/material';
import { convertAxiosErrorToUserFacingMessage, useApiClient } from '../../context/ApiClientContext';
import DxHxForm, { dxHxDefaultValues } from './DxHxForm';
import DxHxSaveAsNewButton from './DxHxSaveAsNewButton';
import basicServiceHandler from '../../services/basicServiceHandler';
import useToast from '../../hooks/useToast';
import { useForm } from '../../components/useForm';

export default function DxHxPane(props) {
  const {
    dxHxId, refreshParent, updateCallback,
  } = props;

  const apiClient = useApiClient();
  const { toastSetErrorNotification, toastSetSuccessNotification } = useToast();

  const {
    values,
    setValues,
    handleInputChange,
  } = useForm(dxHxDefaultValues);

  useEffect(() => {
    basicServiceHandler(
      () => apiClient.getDxHx(dxHxId),
      (response) => setValues({ dxHxName: response.data.name }),
      (error) => toastSetErrorNotification(convertAxiosErrorToUserFacingMessage(error)),
      () => {},
    );
  }, [dxHxId]);

  const onSubmit = () => apiClient.updateDxHx(dxHxId, values.dxHxName);

  const onSuccess = () => {
    if (updateCallback) {
      updateCallback(values.dxHxName);
    }
    refreshParent();
  };

  return (
    values
      ? (
        <>
          <DxHxForm
            values={values}
            setValues={setValues}
            handleInputChange={handleInputChange}
            onSubmit={onSubmit}
            onSuccess={onSuccess}
            successMsg="Update successful!"
            errorMsg="Error updating DxHx"
          />
          <Grid container>
            <DxHxSaveAsNewButton
              sourceDxHxId={dxHxId}
              sourceDxHxName={values.dxHxName}
              onSuccess={() => {
                toastSetSuccessNotification('New DxHx created (see bottom of DxHx list)');
                refreshParent();
              }}
              onError={(error) => (
                toastSetErrorNotification(convertAxiosErrorToUserFacingMessage(error))
              )}
            />
          </Grid>
        </>
      ) : <CircularProgress />
  );
}

DxHxPane.propTypes = {
  dxHxId: PropTypes.number.isRequired,
  refreshParent: PropTypes.func.isRequired,
  updateCallback: PropTypes.func,
};

DxHxPane.defaultProps = {
  updateCallback: null,
};
